export interface ShareTarget {
  id: string;
  label: string;
  /** Builds the share-intent URL that opens the network's composer. */
  buildUrl: (link: string, text: string) => string;
}

export const SHARE_TARGETS: ShareTarget[] = [
  {
    id: 'facebook',
    label: 'Facebook',
    buildUrl: (link) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
  },
  {
    id: 'x',
    label: 'X',
    buildUrl: (link, text) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`,
  },
  {
    id: 'telegram',
    label: 'Telegram',
    buildUrl: (link, text) =>
      `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`,
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    buildUrl: (link, text) => `https://wa.me/?text=${encodeURIComponent(`${text} ${link}`.trim())}`,
  },
];
